var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0f5d265094f9a6c5166db2330f1eb645323d9028"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["vvmt-back@pathtech-gk"]={id:"0f5d265094f9a6c5166db2330f1eb645323d9028"};
      